import React from 'react';
import Text from '../../components/Text';
import { fontSizes } from '../../constants/constants';
import ViewItems from '../../components/ViewItems';
import ViewReverse from '../../components/ViewReverse';
import { Dropdown } from '../../components';
import CustomInput from '../../components/CustomInput';
import Button from '../../components/Button';
import { rowReverseStylesm } from '../../utils/styles';
import beneficiaryFunctional from './index.function';
import { Formik } from 'formik';
import {
  beneficiary_schema,
  beneficiary_validation_schema,
} from '../../validations_schemas/beneficiary_validation_schema';
import ErrorText from '../../components/ErrorText';
import OtpModal from '../../components/OtpModal';
import ConfirmModal from '../../components/ConfirmModal';
import { BeneficieryView } from './components';
import Loader from '../../components/Loader';
import Divider from '../../components/Divider';
import { cn } from '../../utils/utils';

const Beneficiaries = () => {
  const {
    TextWeight,
    isArabic,
    beneficiaryData,
    transferLoading,
    beneficiaryList,
    getContentKey,
    otpModal,
    toogleOtpModal,
    onVerifyOtp,
    onSubmit,
    beneficiaryLoading,
    beneficiaryDeleteLoading,
    onPressDelete,
    onPressActivate,
    selectedBeneficiary,
    setSelectedBeneficiary,
    confirmModal,
    toogleConfirmModal,
    clientDetails,
    transactionLoading,
    selectedIndex,
    onPressCancel,
    activateLoading,
    direction,
  } = beneficiaryFunctional();

  return (
    <div>
      <Text
        text={getContentKey('heading')}
        weight={TextWeight.bold}
        size={fontSizes.h18}
      />

      <Formik
        validationSchema={beneficiary_validation_schema}
        initialValues={{ ...beneficiary_schema, iban: 'SA' || '' }}
        onSubmit={(values, functions) => onSubmit(values, functions?.resetForm)}
        validateOnBlur={false}
        validateOnChange={false}
      >
        {({
          handleSubmit,
          setFieldValue,
          setFieldError,
          resetForm,
          values,
          errors,
        }) => {
          const is_local = values?.type?.id === 1574;
          const isValid =
            values?.type &&
            (is_local ? values?.bank : values?.non_ksa_bank) &&
            (is_local ? true : values?.non_ksa_beneficiary) &&
            (is_local ? values?.branch : values?.non_ksa_branch) &&
            (is_local ? true : values?.registered_address) &&
            (is_local ? true : values?.swift_code) &&
            (is_local ? values?.iban : values?.non_ksa_iban);

          return (
            <ViewItems
              className={'border border-grey mt-2 rounded-lg shadow px-5 py-3'}
            >
              <ViewReverse
                className={cn('w-full gap-6 mt-3 flex-col mb-4', rowReverseStylesm(
                  isArabic
                ))}
              >
                <ViewItems className={'w-full md:w-1/2'}>
                  <Dropdown
                    label={getContentKey('type')}
                    options={beneficiaryData?.beneficiaryTypeList}
                    selectedValue={values?.type}
                    onSelect={(val) => {
                      if (is_local) {
                        resetForm();
                      }
                      setFieldValue('type', val);
                      setFieldError('type', null);
                    }}
                    isRequired={true}
                    valueKey={'name'}
                    isError={errors?.type}
                  />
                  {errors?.type && (
                    <ErrorText
                      text={errors?.type}
                      getContentKey={getContentKey}
                    />
                  )}
                </ViewItems>
                {is_local ? (
                  <ViewItems className={'w-full md:w-1/2'}>
                    <Dropdown
                      label={getContentKey('bank_name')}
                      options={beneficiaryData?.bankNameList}
                      selectedValue={values?.bank}
                      onSelect={(val) => {
                        setFieldValue('bank', val);
                        setFieldError('bank', null);
                      }}
                      valueKey={'name'}
                      isRequired={true}
                      isError={errors?.bank}
                    />
                    {errors?.bank && (
                      <ErrorText
                        text={errors?.bank}
                        getContentKey={getContentKey}
                      />
                    )}
                  </ViewItems>
                ) : (
                  <ViewItems className={'w-full md:w-1/2'}>
                    <CustomInput
                      label={getContentKey('bank_name')}
                      placeholder={getContentKey('enter_name')}
                      isFullborder
                      isRounded
                      value={values?.non_ksa_bank}
                      isRequired={true}
                      onChange={(e) =>
                        setFieldValue('non_ksa_bank', e.target.value)
                      }
                      errorMessage={getContentKey(errors?.non_ksa_bank)}
                    />
                  </ViewItems>
                )}
              </ViewReverse>

              {is_local ? (
                <>
                  <ViewReverse
                    className={cn('w-full gap-6 flex-col', is_local && 'mb-4', rowReverseStylesm(
                      isArabic
                    ))}
                  >
                    <ViewItems className={'w-full'}>
                      <CustomInput
                        label={getContentKey('beneficiery_name')}
                        placeholder={getContentKey('beneficiary_placeholder')}
                        isFullborder
                        isRounded
                        value={clientDetails?.clientInformation?.clientName}
                        isDisabled={is_local}
                        onChange={(e) => {
                          setFieldValue('beneficiary', e?.target?.value);
                          setFieldError('beneficiary', null);
                        }}
                        isError={errors?.beneficiary}
                      />
                      {errors?.beneficiary && (
                        <ErrorText
                          text={errors?.beneficiary}
                          getContentKey={getContentKey}
                        />
                      )}
                    </ViewItems>
                    <ViewItems className={'w-full'}>
                      <CustomInput
                        label={getContentKey('iban')}
                        placeholder={getContentKey('iban_placeholder')}
                        isFullborder
                        isRounded
                        isRequired={true}
                        value={values?.iban?.toUpperCase()}
                        onChange={(e) => {
                          if (!e.target.value.startsWith('SA') && is_local) {
                            e.target.value = 'SA';
                          }
                          setFieldValue('iban', e?.target?.value);
                          setFieldError('iban', null);
                        }}
                        isError={errors?.iban}
                        maxLength={24}
                      />
                      {errors?.iban && (
                        <ErrorText
                          text={errors?.iban}
                          getContentKey={getContentKey}
                        />
                      )}
                    </ViewItems>
                  </ViewReverse>

                  <ViewReverse
                    className={cn('w-full gap-6 flex-col mb-4', rowReverseStylesm(
                      isArabic
                    ))}
                  >
                    <ViewItems className={'w-full sm:w-1/2'}>
                      <CustomInput
                        label={getContentKey('branch')}
                        placeholder={getContentKey('enter_name')}
                        value={values?.branch}
                        isRequired={true}
                        onChange={(e) => {
                          setFieldValue('branch', e.target.value);
                          setFieldError('branch', null);
                        }}
                        valueKey={'name'}
                        isError={errors?.branch}
                        isRounded
                      />
                      {errors?.branch && (
                        <ErrorText
                          text={errors?.branch}
                          getContentKey={getContentKey}
                        />
                      )}
                    </ViewItems>
                    {/* <ViewItems className={'w-full'}>
                      <Dropdown
                        label={getContentKey('currency')}
                        options={beneficiaryData?.currencyList}
                        selectedValue={beneficiaryData?.currencyList?.[0]}
                        onSelect={(val) => {
                          setFieldValue('currency', val);
                          setFieldError('currency', null);
                        }}
                        valueKey={'name'}
                        isDisabled={true}
                        isError={errors?.currency}
                      />
                      {errors?.currency && (
                        <ErrorText
                          text={errors?.currency}
                          getContentKey={getContentKey}
                        />
                      )}
                    </ViewItems> */}
                    <div className='w-1/2 hidden sm:block' />
                  </ViewReverse>
                </>
              ) : (
                <>
                  <ViewReverse
                    className={cn('w-full gap-6 flex-col', is_local && 'mb-4', rowReverseStylesm(
                      isArabic
                    ))}
                  >
                    <ViewItems className={'w-full'}>
                      <CustomInput
                        label={getContentKey('beneficiery_name')}
                        placeholder={getContentKey('beneficiary_placeholder')}
                        isFullborder
                        isRounded
                        isRequired={true}
                        value={values?.non_ksa_beneficiary}
                        onChange={(e) => {
                          setFieldValue(
                            'non_ksa_beneficiary',
                            e?.target?.value
                          );
                          setFieldError('non_ksa_beneficiary', null);
                        }}
                        isError={errors?.non_ksa_beneficiary}
                      />
                      {errors?.non_ksa_beneficiary && (
                        <ErrorText
                          text={errors?.non_ksa_beneficiary}
                          getContentKey={getContentKey}
                        />
                      )}
                    </ViewItems>
                    <ViewItems className={'w-full'}>
                      <CustomInput
                        label={getContentKey('iban')}
                        placeholder={getContentKey('iban_placeholder')}
                        isFullborder
                        isRounded
                        isRequired={true}
                        value={values?.non_ksa_iban?.toUpperCase()}
                        onChange={(e) => {
                          setFieldValue('non_ksa_iban', e?.target?.value);
                          setFieldError('non_ksa_iban', null);
                        }}
                        isError={errors?.non_ksa_iban}
                        maxLength={34}
                      />
                      {errors?.non_ksa_iban && (
                        <ErrorText
                          text={errors?.non_ksa_iban}
                          getContentKey={getContentKey}
                        />
                      )}
                    </ViewItems>
                  </ViewReverse>

                  <ViewReverse className={cn('w-full gap-6 flex-col mt-4', rowReverseStylesm(
                    isArabic
                  ))}>
                    <ViewItems className={'w-full'}>
                      <CustomInput
                        label={getContentKey('branch')}
                        placeholder={getContentKey('enter_name')}
                        value={values?.non_ksa_branch}
                        onChange={(e) => {
                          setFieldValue('non_ksa_branch', e.target.value);
                          setFieldError('non_ksa_branch', null);
                        }}
                        valueKey={'name'}
                        isRequired={true}
                        isError={errors?.non_ksa_branch}
                        isRounded
                      />
                      {errors?.non_ksa_branch && (
                        <ErrorText
                          text={errors?.non_ksa_branch}
                          getContentKey={getContentKey}
                        />
                      )}
                    </ViewItems>
                    <ViewItems className={'w-full'}>
                      <CustomInput
                        label={getContentKey('registered_address')}
                        placeholder={getContentKey('enter_address_placeholder')}
                        isFullborder
                        isRounded
                        width='w-full'
                        isRequired={true}
                        value={values?.registered_address}
                        onChange={(e) =>
                          setFieldValue('registered_address', e.target.value)
                        }
                      />
                      {errors?.registered_address && (
                        <ErrorText
                          text={errors?.registered_address}
                          getContentKey={getContentKey}
                        />
                      )}
                    </ViewItems>
                  </ViewReverse>
                  <ViewReverse className={cn('w-full mt-4 gap-6 flex-col', rowReverseStylesm(
                    isArabic
                  ))}>
                    <ViewItems className={'w-full'}>
                      <CustomInput
                        label={getContentKey('aba_routing_number')}
                        placeholder={getContentKey('enter_number_placeholder')}
                        isFullborder
                        isRounded
                        width='w-full'
                        value={values?.aba_routing}
                        onChange={(e) =>
                          setFieldValue('aba_routing', e.target.value)
                        }
                      />
                      {errors?.aba_routing && (
                        <ErrorText
                          text={errors?.aba_routing}
                          getContentKey={getContentKey}
                        />
                      )}
                    </ViewItems>
                    <ViewItems className='w-full mb-4'>
                      <CustomInput
                        label={getContentKey('swift_code')}
                        placeholder={getContentKey('swift_code_placeholder')}
                        isFullborder
                        maxLength={11}
                        isRounded
                        width='w-full'
                        value={values?.swift_code}
                        isRequired={true}
                        onChange={(e) =>
                          setFieldValue(
                            'swift_code',
                            e.target.value?.toUpperCase()
                          )
                        }
                      />
                    </ViewItems>
                  </ViewReverse>
                </>
              )}

              <Divider margin={'my-0'} />

              <ViewReverse className='items-center gap-2 mt-4 mb-6'>
                <Button
                  text={getContentKey('submit')}
                  bgColor='bg-primary'
                  className={'w-36 px-0 text-center'}
                  onClick={handleSubmit}
                  isDisabled={!isValid}
                  loading={beneficiaryLoading || transferLoading}
                />
                <Button
                  text={getContentKey('clear')}
                  color='text-primary'
                  bgColor='bg-white'
                  onClick={resetForm}
                  className={'border border-primary w-36 px-0 text-center'}
                />
              </ViewReverse>

              <OtpModal
                open={otpModal}
                onVerify={() => onVerifyOtp(values, resetForm)}
                onClose={toogleOtpModal}
                type={6}
              />
            </ViewItems>
          );
        }}
      </Formik>
      {beneficiaryList?.length > 0 ? (
        <div dir={direction} className='grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 w-full mt-4 items-start'>
          {beneficiaryList?.map((item, index) => (
            <BeneficieryView
              item={item}
              getContent={getContentKey}
              key={index}
              onDelete={() =>
                onPressDelete(item?.id, item?.beneficiaryTypeId, index)
              }
              onCancel={() =>
                onPressCancel(item?.id, item?.beneficiaryTypeId, index, item?.pendingRequestId)
              }
              onPressActivate={() =>
                onPressActivate(item?.id, index, item?.beneficiarySource)
              }
              loading={beneficiaryDeleteLoading && selectedIndex === index}
              activateLoading={activateLoading && selectedIndex === index}
            />
          ))}
        </div>
      ) : (
        !transactionLoading &&
        <Text
          text={getContentKey('no_beneficiaries_found')}
          size={fontSizes.h16}
          isCenter
          className={'mt-10'}
        />
      )}

      {transactionLoading && (
        <Loader width={'w-8'} height={'h-8'} className={'mt-10'} />
      )}
      {/* <CustomTable
          heading={getContentKey('beneficiery_list')}
          headCells={isArabic ? beneficiaryColumns(getContentKey)?.reverse() : beneficiaryColumns(getContentKey)}
          data={beneficiaryList}
          isOpen
          onPress={(data) => {
            setSelectedBeneficiary(data);
            toogleConfirmModal();
          }}
          loading={transactionLoading}
        /> */}

      <ConfirmModal
        open={confirmModal}
        onClose={toogleConfirmModal}
        onConfirm={() => {
          selectedBeneficiary?.status === 'Pending'
            ? onPressActivate(selectedBeneficiary?.id)
            : onPressDelete(selectedBeneficiary?.id);
        }}
        title={`${selectedBeneficiary?.status === 'Pending'
          ? getContentKey('activate')
          : getContentKey('delete')
          } ${getContentKey('beneficiary')}`}
        description={`${getContentKey('are_you_sure')} ${selectedBeneficiary?.status === 'Pending'
          ? getContentKey('activate')
          : getContentKey('delete')
          } ${getContentKey('beneficiary')}?`}
      />
    </div>
  );
};

export default Beneficiaries;
